import { defineStore } from 'pinia';
import { getStoredCookiePreferences } from '@resources/js/api/cookiePreferences';

const PREFERENCE_ACCEPT_ALL = 'accept_all';
const PREFERENCE_REJECT_NON_ESSENTIAL = 'reject_non_essential';
const PREFERENCE_CUSTOMIZE = 'customize';
const STORAGE_KEY = 'crowdblue_cookie_preferences';

function hydrateFromStorage() {
  const stored = getStoredCookiePreferences();
  if (!stored) {
    return {
      preferenceType: null,
      categories: { analytics: false, performance: false, advertising: false },
      expiresAt: null,
    };
  }
  return {
    preferenceType: stored.preference_type || null,
    categories: stored.categories
      ? {
          analytics: Boolean(stored.categories.analytics),
          performance: Boolean(stored.categories.performance),
          advertising: Boolean(stored.categories.advertising),
        }
      : { analytics: false, performance: false, advertising: false },
    expiresAt: stored.expires_at || null,
  };
}

export const useCookiePreferencesStore = defineStore('cookiePreferences', {
  state: () => hydrateFromStorage(),
  getters: {
    isAdvertisingAllowed(state) {
      if (!state.preferenceType) return false;
      if (state.preferenceType === PREFERENCE_REJECT_NON_ESSENTIAL) return false;
      if (state.preferenceType === PREFERENCE_CUSTOMIZE) {
        return Boolean(state.categories && state.categories.advertising);
      }
      return true;
    },
    isAnalyticsAllowed(state) {
      if (!state.preferenceType) return false;
      if (state.preferenceType === PREFERENCE_REJECT_NON_ESSENTIAL) return false;
      if (state.preferenceType === PREFERENCE_CUSTOMIZE) {
        return Boolean(state.categories && state.categories.analytics);
      }
      return true;
    },
  },
  actions: {
    setPreferences(data) {
      if (!data) return;
      this.preferenceType = data.preference_type || null;
      if (data.categories && typeof data.categories === 'object') {
        this.categories = {
          analytics: Boolean(data.categories.analytics),
          performance: Boolean(data.categories.performance),
          advertising: Boolean(data.categories.advertising),
        };
      }
      this.expiresAt = data.expires_at || null;
      try {
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            preference_type: this.preferenceType,
            categories: this.categories,
            expires_at: this.expiresAt,
          })
        );
      } catch (e) {}
    },
    loadFromStorage() {
      const hydrated = hydrateFromStorage();
      this.preferenceType = hydrated.preferenceType;
      this.categories = hydrated.categories;
      this.expiresAt = hydrated.expiresAt;
    },
  },
});
